import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";

interface Parameter {
    scrollData: number;
    pageUrl: string;
}

type HandlerType = Handler<Parameter, StoreHandlerProps>;

export const DispatchScrollData: HandlerType = props => {
    const { scrollData } = props.parameter;
    props.dispatch({
        type: "Store/Pages/ProductList/DispatchScrollData",
        scrollData: scrollData,
    });
};

export const DispatchCatalogPageUrl: HandlerType = props => {
    const { pageUrl } = props.parameter;
    props.dispatch({
        type: "Store/Pages/ProductList/DispatchCatalogPageUrl",
        pageUrl: pageUrl,
    });
};

export const chain = [DispatchScrollData, DispatchCatalogPageUrl];

const dispatchCatalogPageData = createHandlerChainRunner(chain, "DispatchCatalogPageData");
export default dispatchCatalogPageData;
